/**
 * Checks if the given phase is within the specified range in a cyclic manner.
 * @param from The start of the range (inclusive).
 * @param to The end of the range (exclusive).
 * @param phase The current phase to check.
 * @param cycle The length of the cycle.
 * @returns 1 if the phase is within the range, 0 otherwise.
 */
export function pulse(from: number, to: number, phase: number, cycle: number): 0 | 1 {
  const mod = ((phase % cycle) + cycle) % cycle;
  return mod >= from && mod < to ? 1 : 0;
}